var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('spreadsheet',{key:"budgetRestrictionsTable",staticClass:"mt-2",attrs:{"columns":_vm.columns},on:{"input":_vm.updatedSpreadsheet},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }